import React from 'react';
import { createStyleSheet } from '../../utils';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { Focusable } from '../Focusable';
import { Icon } from '../Icon';
export const Checkbox = ({ style, disabled, checked, onChange }) => {
    const styles = useStyleSheet(getStyles);
    const { size, color } = useThemeContext();
    return (React.createElement(Focusable, { style: [styles.container, checked ? styles.checked : {}, style], hoverStyle: checked ? styles.checkedHovered : styles.hovered, disabled: disabled, onPress: () => {
            if (onChange)
                onChange(!checked);
        } }, checked ? (React.createElement(Icon, { name: 'checkmark', size: size.E, color: color.white.p100 })) : null));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        width: size.J,
        height: size.J,
        borderRadius: size.A + size.B,
        borderColor: color.invert2.p16,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    checked: {
        backgroundColor: color.primary.solid,
        borderColor: color.primary.solid
    },
    hovered: { backgroundColor: color.invert2.p4 },
    checkedHovered: {
        backgroundColor: color.primary.solidHover,
        borderColor: color.primary.solidHover
    }
}));
//# sourceMappingURL=index.js.map